import {Box, Dialog, DialogContent, Divider, Table, TableBody, TableContainer, Typography} from '@mui/material';
import moment from "moment/moment";
import {useEffect, useState} from "react";
import {searchTripApiV2} from "../../api/trip";
import {useLocales} from "../../locales";
import {TableHeadCustom, TableNoData, TablePaginationCustom, TableSkeleton, useTable} from "../../components/table";
import {useFormContext} from "react-hook-form";
import Scrollbar from "../../components/Scrollbar";
import DepartureFromSpotToolbar from "./DepartureFromSpotToolbar";
import DepartureFromSpotTableRow from "./DepartureFromSpotTableRow";
import {useSelector} from "../../redux/store";

const TABLE_HEAD = (translate, arrivalStationName) => [
    {id: "lineName", label: "Linija", align: "left"},
    {id: "operatorName", label: "Prevoznik", align: "left"},
    {id: "departureTime", label: "Polazak iz mesta", align: "left"},
    {id: "arrivalTime", label: `Dolazak u ${arrivalStationName}`, align: "left"},
    {id: "canceledNote", label: "Komentar", align: "left"},
    {id: "", width: 10, sortable: false}
];

export default function InfoDialog({data, open, onClose}) {
    const {translate} = useLocales();
    const {
        dense,
        page,
        order,
        orderBy,
        rowsPerPage,
        setPage,
        onSort,
        onChangeDense,
        onChangePage,
        onChangeRowsPerPage
    } = useTable({
        defaultOrderBy: "id"
    });

    const {homeArrStations} = useSelector(state => state.stations);
    const {getValues} = useFormContext();
    const [openRowId, setOpenRowId] = useState(null);
    const [enableAllStations, setEnableAllStations] = useState(false)
    const toLocationId = getValues('toLocationId')
    const [foundResult, setFoundResult] = useState([])
    const [endStation, setEndStation] = useState(data?.arrStationId)
    const [filterLineName, setFilterLineName] = useState("");
    const [filterOperatorName, setFilterOperatorName] = useState(data?.operator || "");
    const [filterDate, setFilterDate] = useState(moment(data?.dateFrom).format("YYYY-MM-DD HH:mm:ss") || new Date());
    const [filterDateTo, setFilterDateTo] = useState(moment(data?.dateFrom).add(1, 'day').format("YYYY-MM-DD HH:mm:ss") || moment().add(1, 'day').toDate());
    const [filterCanceledNote, setFilterCanceledNote] = useState("");
    const [filterDepartureTime, setFilterDepartureTime] = useState(null);
    const [filterRootDepartureTime, setFilterRootDepartureTime] = useState(null);
    const [filterArrivalTime, setFilterArrivalTime] = useState(null);
    const [showWithComment, setShowWithComment] = useState(false);

    const [loadingLines, setLoadingLines] = useState(false);

    const isFiltered = filterLineName !== "" ||
        filterOperatorName !== "" ||
        filterCanceledNote !== "" ||
        filterDepartureTime !== null ||
        filterRootDepartureTime !== null ||
        filterArrivalTime !== null

    const baseFilteredData = applyFilter({
        inputData: foundResult,
        filterLineName: filterLineName,
        filterOperatorName: filterOperatorName,
        filterCanceledNote: filterCanceledNote,
        filterDepartureTime: null,
        filterRootDepartureTime: null,
        filterArrivalTime: null,
        showWithComment: showWithComment,
        order: order,
        orderBy: orderBy
    })

    const departureTimeOptions = [...new Set(baseFilteredData.map(item => item.departureTime).filter(Boolean))].sort();
    const rootDepartureTimeOptions = [...new Set(baseFilteredData.map(item => item.rootDepartureTime).filter(Boolean))].sort();
    const arrivalTimeOptions = [...new Set(baseFilteredData.map(item => item.arrivalTime).filter(Boolean))].sort();

    const filteredData = applyFilter({
        inputData: foundResult,
        filterLineName: filterLineName,
        filterOperatorName: filterOperatorName,
        filterCanceledNote: filterCanceledNote,
        filterDepartureTime: filterDepartureTime,
        filterRootDepartureTime: filterRootDepartureTime,
        filterArrivalTime: filterArrivalTime,
        showWithComment: showWithComment,
        order: order,
        orderBy: orderBy
    })

    useEffect(() => {
        if (endStation) {
            setLoadingLines(true)
            searchTripApiV2({
                departureStationId: endStation.id || endStation || null,
                arrivalStationId: data?.depStationId,
                from: moment(filterDate).startOf('day').format("YYYY-MM-DD"),
                to: moment(filterDateTo).startOf('day').format("YYYY-MM-DD"),
                opId: data?.operatorId || null,
                //toLocationId: endStation.locationId || null,
                showWithoutRate: true
            }).then(({data}) => {
                setFoundResult(data)
            }).catch(e => {
                console.error(e, "EEE")
            }).finally(() => {
                setLoadingLines(false)
            })
        }

    }, [filterDate, filterDateTo, endStation]);

    const handleFilterLineName = (event) => {
        setPage(0);
        setFilterLineName(event.target.value);
    };

    const handleFilterOperatorName = (event) => {
        setPage(0);
        setFilterOperatorName(event.target.value);
    };

    const handleFilterCanceledNote = (event) => {
        setPage(0);
        setFilterCanceledNote(event.target.value);
    };

    const handleResetFilter = () => {
        setFilterLineName("");
        setFilterOperatorName("");
        setFilterDate(null);
        setFilterDateTo(null);
        setFilterCanceledNote("");
        setFilterDepartureTime(null);
        setFilterRootDepartureTime(null);
        setFilterArrivalTime(null);
    };
    return (
        <Dialog fullWidth maxWidth="xl" open={open} onClose={onClose}>
            <DialogContent sx={{pb: 2}}>
                <Box mb={3}>
                    <Typography
                        variant="h6"
                        sx={{fontWeight: 'bold', mb: 2}}
                    >
                        Povratak iz mesta
                    </Typography>
                    <Divider/>
                </Box>
                <DepartureFromSpotToolbar
                    arrStationId={data.arrStationId}
                    toLocationId={toLocationId}
                    enableAllStations={enableAllStations}
                    setEnableAllStations={setEnableAllStations}
                    isIndividual={data?.isIndividual}
                    homeArrStations={toLocationId ? homeArrStations?.filter(f => f.locationId === toLocationId) : homeArrStations}
                    setEndStation={setEndStation}
                    endStation={endStation}
                    operator={data?.operator}
                    isFiltered={isFiltered}
                    filterLineName={filterLineName}
                    filterOperatorName={filterOperatorName}
                    filterDate={filterDate}
                    filterDateTo={filterDateTo}
                    onFilterDate={(newValue) => {
                        setFilterDate(newValue)
                    }}
                    onFilterDateTo={(newValue) => {
                        setFilterDateTo(newValue)
                    }}
                    onFilterLineName={handleFilterLineName}
                    onFilterOperatorName={handleFilterOperatorName}
                    filterCanceledNote={filterCanceledNote}
                    onFilterCanceledNote={handleFilterCanceledNote}
                    filterDepartureTime={filterDepartureTime}
                    onFilterDepartureTime={setFilterDepartureTime}
                    filterRootDepartureTime={filterRootDepartureTime}
                    onFilterRootDepartureTime={setFilterRootDepartureTime}
                    filterArrivalTime={filterArrivalTime}
                    onFilterArrivalTime={setFilterArrivalTime}
                    departureTimeOptions={departureTimeOptions}
                    rootDepartureTimeOptions={rootDepartureTimeOptions}
                    arrivalTimeOptions={arrivalTimeOptions}
                    onResetFilter={handleResetFilter}
                    showWithComment={showWithComment}
                    onShowWithComment={setShowWithComment}
                />

                <TableContainer sx={{position: "relative", overflow: "unset"}}>
                    <Scrollbar>
                        <Table size={dense ? "small" : "medium"} sx={{minWidth: 960}}>
                            <TableHeadCustom
                                order={order}
                                orderBy={orderBy}
                                headLabel={TABLE_HEAD(translate, data?.arrivalStationName)}
                                rowCount={foundResult?.length || 0}
                                onSort={onSort}
                            />


                            <TableBody>
                                {loadingLines ?
                                    Array.from({length: rowsPerPage}, (_, i) => (
                                        <TableSkeleton key={i} columns={TABLE_HEAD(translate).length}/>
                                    ))
                                    :
                                    filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) =>
                                        <DepartureFromSpotTableRow
                                            key={index}
                                            index={index}
                                            openRowId={openRowId}
                                            setOpenRowId={setOpenRowId}
                                            row={row}
                                        />)
                                }
                                <TableNoData isNotFound={!loadingLines && filteredData.length === 0}/>
                            </TableBody>
                        </Table>
                    </Scrollbar>
                </TableContainer>

                <TablePaginationCustom
                    loading={loadingLines}
                    count={filteredData?.length || 0}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={onChangePage}
                    onRowsPerPageChange={onChangeRowsPerPage}
                    //
                    dense={dense}
                    onChangeDense={onChangeDense}
                />
            </DialogContent>
        </Dialog>
    );
}

function applyFilter({
                         inputData,
                         filterLineName,
                         filterOperatorName,
                         filterCanceledNote,
                         filterDepartureTime,
                         filterRootDepartureTime,
                         filterArrivalTime,
                         showWithComment,
                         order,
                         orderBy
                     }) {

    if (!showWithComment) {
        inputData = inputData.filter((product) => !product.canceledNote || product.canceledNote.trim() === "");
    }

    if (filterLineName) {
        inputData = inputData.filter((product) => product.lineName.toLowerCase().indexOf(filterLineName.toLowerCase()) !== -1);
    }

    if (filterOperatorName) {
        inputData = inputData.filter((product) => product.operatorName.toLowerCase().indexOf(filterOperatorName.toLowerCase()) !== -1);
    }

    if (filterCanceledNote) {
        inputData = inputData.filter((product) => (product.canceledNote || "").toLowerCase().indexOf(filterCanceledNote.toLowerCase()) !== -1);
    }

    if (filterDepartureTime) {
        inputData = inputData.filter((product) => product.departureTime === filterDepartureTime);
    }

    if (filterRootDepartureTime) {
        inputData = inputData.filter((product) => product.rootDepartureTime === filterRootDepartureTime);
    }

    if (filterArrivalTime) {
        inputData = inputData.filter((product) => product.arrivalTime === filterArrivalTime);
    }

    if (orderBy) {
        inputData = [...inputData].sort((a, b) => {
            let aValue = a[orderBy];
            let bValue = b[orderBy];

            if (aValue == null) aValue = '';
            if (bValue == null) bValue = '';

            if (typeof aValue === 'string' && typeof bValue === 'string') {
                const comparison = aValue.localeCompare(bValue, 'sr', {sensitivity: 'base'});
                return order === 'asc' ? comparison : -comparison;
            }

            if (aValue < bValue) return order === 'asc' ? -1 : 1;
            if (aValue > bValue) return order === 'asc' ? 1 : -1;
            return 0;
        });
    }

    return inputData;
}
